/**
 * Blog category filter.
 *
 * Submits the filter form as soon as a topic is picked and hides the now-redundant Filter button; without JS the
 * form still submits through the button.
 */
document.querySelectorAll<HTMLFormElement>('form[data-category-filter]').forEach((form) => {
	form.querySelector('select')?.addEventListener('change', () => form.requestSubmit());
	form.querySelector('[data-category-filter-submit]')?.classList.add('hidden');
});
